import { Button, Stack, useTheme } from "@mui/material";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import ItemDetails from "../../../components/checkout/ItemDetails";
import { useShopContext } from "../../../context/shop/shop.context";

interface RecapStepProps {
  handlePrev: () => void;
}
const RecapStep = ({ handlePrev }: RecapStepProps) => {
  const { shopState, shopDispatch } = useShopContext();
  const theme = useTheme();
  const router = useRouter();
  const { t } = useTranslation();

  return (
    <Stack>
      {shopState.items.map((item, index) => (
        <ItemDetails key={index} item={item} disabled />
      ))}

      <Stack flexDirection="row">
        <Button onClick={handlePrev} variant="contained">
          {t("page_checkout.recap.prev")}
        </Button>
        {/* <Button onClick={handleNext} variant="contained">
            {t("page_checkout.recap.next")}
          </Button> */}
      </Stack>
    </Stack>
  );
};

export default RecapStep;
